import React, { useEffect, Fragment, useState } from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from 'react-redux';

import * as Loadings from '../../constants/loadings/user';
import JwtDecode from 'jwt-decode';
import { fetchUserById, getProfilePicture, fetchPartnerCustomization, getDocuments } from '../../actions/user-api';

import * as axios from 'axios';
import { getUserRepresentingById } from '../../actions/facilita-api';
import { LoadingState } from '../../_common/loadingState';

// Referent
// ==========================================
// Referent: Common
import { Navbar } from './_common/navbar';
import { Help } from './_common/help';
import { Path } from './_common/path';

// Facilita: Views
import { Landing } from './landing';
import { Settings } from './settings';
import { Dossier } from './dossier';
import { Declarer } from './declarer';
import { Onboarding } from './onboarding';

import * as R from 'ramda';
import { FileTypes } from '../../constants/utils/fileTypes';
// import Dossier from './dossier';

export const Facilita = () => {
	const dispatch = useDispatch();
	const location = useLocation();
	const router = useSelector(state => state.router);
	const userState = useSelector(state => state.facilita);
	const user = useSelector(state => state.user);
	const deathDeclarationState = useSelector(state => state.deathDeclaration);
	const [roles, setRoles] = useState([]);

	const [partnerCustomization, setPartnerCustomization] = useState({
		isLoaded: false,
		logoBase64Encoded: undefined,
		color: undefined,
		isDemo: false
	});


	useEffect(() => {
		var accessToken = sessionStorage.getItem("access_token");

		if (!R.isNil(accessToken)) {
			axios.defaults.headers.common['Authorization'] = "Bearer " + accessToken;
			var decoded = JwtDecode(accessToken);
			if (!R.isNil(decoded) && !R.isNil(decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"])) {
				dispatch(fetchUserById(decoded["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/nameidentifier"]));
			}
			if (!R.isNil(decoded) && !R.isNil(decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"])) {
				setRoles(decoded["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"]);
			}
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);


	useEffect(() => {
		if (!R.isNil(userState.user)) {
			dispatch(getDocuments(user.user));
			dispatch(getUserRepresentingById(userState.user.id));
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [userState.user]);

	useEffect(() => {
		const profilePicture = user.documents.find(d => d.fileType === FileTypes.ProfilePicture);
		if (!R.isNil(profilePicture))
			dispatch(getProfilePicture(user.user.id, profilePicture.fileName));

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user.documents]);

	useEffect(() => {
		if ((!R.isNil(deathDeclarationState.user) && !R.isNil(deathDeclarationState.user.partnerId) && deathDeclarationState.user.partnerId !== '00000000-0000-0000-0000-000000000000') ||
			(!R.isNil(deathDeclarationState.declaration) && !R.isNil(deathDeclarationState.declaration.partnerId) && deathDeclarationState.declaration.partnerId !== '00000000-0000-0000-0000-000000000000')) {
			const customizationUserPartnerId = !R.isNil(deathDeclarationState.user) ? deathDeclarationState.user.partnerId : deathDeclarationState.declaration.partnerId;
			dispatch(fetchPartnerCustomization(customizationUserPartnerId))
				.then((customization) => {
					if (!R.isNil(customization) && !R.isNil(customization.data)) {
						setPartnerCustomization({ ...customization.data, isLoaded: true });
					}
				})
				.catch(() => setPartnerCustomization({ ...partnerCustomization, isLoaded: true }));
		} else {
			setPartnerCustomization({ color: undefined, logoBase64Encoded: undefined, isLoaded: true, isDemo: false });
		}
	}, [deathDeclarationState.user, deathDeclarationState.declaration]);


	if (!partnerCustomization.isLoaded) {
		return (
			<article className="flex-column mb-auto h-100 scroll-default bg-common rounded">
				<LoadingState />
			</article>
		);
	}


	if (R.isNil(userState.user) || !partnerCustomization.isLoaded) {
		//SHOW A LOADING
		if (userState.isLoading.includes(Loadings.FETCH_USER)) {
			return (
				<article className="flex-column mb-auto h-100 scroll-default bg-common rounded">
					<LoadingState />
				</article>
			);
		}
		return "";
	}
	return (
		<Switch>
			<Route path="/facilita/:userId/declarer/" component={Declarer} />
			<Route path="/facilita/:userId/onboarding">
				<Onboarding user={userState.user} profilePicture={userState.profilePicture} userRepresenting={userState.representing} logoContent={partnerCustomization.logoBase64Encoded} />
			</Route>
			<Fragment>
				<div className={"layout layout-row" + (!R.isNil(partnerCustomization) && !R.isNil(partnerCustomization.color) && partnerCustomization.color !== "" ? "" : " bg-gradient-primary")} style={{ backgroundColor: "#" + partnerCustomization.color }}>
					{/* <div className="layout layout-row bg-gradient-primary"> */}
					<h1 className="sr-only visually-hidden">Assist@</h1>
					<Navbar location={router.location} user={userState.user} profilePicture={userState.profilePicture} userRepresenting={userState.representing} partnerColor={partnerCustomization.color} logoContent={partnerCustomization.logoBase64Encoded} roles={roles} />
					<main role="main" className="view flex-grow-1 bg-gradient-light">
						<h1 className="sr-only visually-hidden">Assist@: Main</h1>
						{/* <div className='container-fluid flex-md-row align-items-center gap-xs pt-3'>
							<Help row={true} />
							<Path userRepresenting={userState.representing} />							
						</div> */}
						<Switch>
							<Route exact path="/facilita">
								<Landing representingUser={R.isEmpty(userState.representing) ? undefined : userState.representing.find(r => !r.isDeceased && r.hasCompletedDossier)} />
							</Route>
							<Route path="/facilita/settings" >
								<Settings roles={roles} />
							</Route>
							{/* <Route path="/facilita/:userId/onboarding" component={Onboarding} /> */}
							<Route
								path="/facilita/:userId"
								render={() => (
									<Dossier
										isDemo={partnerCustomization.isDemo}
									/>
								)}
							/>

							<Route render={() => {
								return <Redirect exact to="/facilita" />;
							}} />
						</Switch>
					</main>
				</div>
			</Fragment>
		</Switch>
	);
};